<template>
  <div>
    <div class="titileDefinition">账号设置</div>
    <div class="section-right-content-box">
      <div class="checked-content-box">
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">系统提示</span>
        </div>
        <top-title style="margin-left: 50px" desc="手机号设置后，可免费接收以下信息！（完全免费）" classType="1"></top-title>
        <div class="checked-box">
          <div class="item">
            <el-checkbox v-model="checkedLin" @change="checkSms" class="check">
              <span style="color:#666666">每天9点前发送前一天自动催付效果、短信发送量和当前短信条数（为避免打扰，每天发送数量超过100条才发送）</span>
            </el-checkbox>
            <el-checkbox v-model="checked" @change="checkSms" class="check">
              <span style="color:#666666">软件短信不足</span>
              <el-input
                v-model="userInfo.balanceRemindNum"
                class="input"
                size="small"
                oninput="value=value.replace(/[^\d]/g,'')"
                style="min-width: 100px"
              ></el-input>
              <span style="color:#666666">条，发送提醒</span>
            </el-checkbox>
            <el-checkbox v-model="checkedOne" @change="checkExp" class="check">
              <span style="color:#666666">软件到期不足</span>
              <el-input v-model="userInfo.softwareExpireDay" class="input" oninput="value=value.replace(/[^\d]/g,'')" size="small"></el-input>
              <span style="color:#666666">天发送提醒。</span>
            </el-checkbox>
            <el-checkbox v-model="checkedFive" class="check">
              <span style="color:#666666">营销批次短信提交成功后发送短信</span>
            </el-checkbox>
            <el-checkbox v-model="checkedSix" class="check">
              <span style="color:#666666">7天未登录软件授权提醒</span>
            </el-checkbox>
          </div>
        </div>
      </div>
      <!-- 数据导出 -->
      <div class="input-content-box">
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">数据导出</span>
        </div>
        <top-title style="margin-left: 50px" desc="为保证客户数据安全性，防止信息泄露，导出系统短信效果、数据分析等可设置验证手机号" classType="1"></top-title>
        <div class="input-box">
         <div class="item">
            <span class="item-name" style="width:123px"><span style="color: red;">*</span>导出数据身份验证</span>
            <span>
                  <el-switch  label="开启状态" v-model="isOpen"
                  :active-value="1" :inactive-value="2" @change="changeSwitch"></el-switch>
            </span>
          </div>
        </div>
      </div>
      <!-- END -->
      <div class="input-content-box">
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">联系人信息</span>
        </div>
        <top-title style="margin-left: 50px" desc="为保障系统安全，在进行敏感操作时，需要通过所留手机号验证操作人身份" classType="1"></top-title>
        <div class="input-box">
          <div class="item">
            &nbsp;&nbsp;
            <span class="item-name">姓名</span>
            <el-input
              v-model="qqPhone.contactName"
              :disabled="editDisabled"
              class="input"
              placeholder="请输入姓名"
              :maxlength="50"
              size="small"
            ></el-input>
            <span class="fenHao">*</span>
          </div>
          <div class="item">
            &nbsp;&nbsp;
            <span class="item-name">QQ</span>
            <el-input
              class="input"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="用于软件指导"
              :disabled="editDisabled"
              v-model="qqPhone.qq"
              size="small"
            ></el-input>
            <span class="fenHao">*</span>
          </div>
          <div class="item">
            <span style="margin-right: 11px">手机号</span>
            <!--  @change="checkPhone"
                  id="phone"
                  @input="verificationCode" -->

            <el-input
              v-model="qqPhone.mobile"
              @change="checkPhone"
              :disabled="editDisabled"
              id="phone"
              @input="verificationCode"
              class="input"
              oninput="value=value.replace(/[^\d]/g,'')"
              :maxlength="11"
              placeholder="仅用于绑定公众号实时监控店铺数据"
              size="small"
            ></el-input>
            <span class="fenHao">*</span>
          </div>
          <div class="item" style="margin-bottom: 40px">
            <span>验证码</span>&nbsp;&nbsp;
            <el-input v-model="message.vcode" type="number" :disabled="editDisabled" class="code-input" size="small"></el-input>
            <el-button plain size="small" v-zoom="{ from: pageName, name: buttonContent }" @click="getMesaage" :disabled="dis || editDisabled">{{
              buttonContent
            }}</el-button>
          </div>
          <div style="text-align: center;border-top: 1px solid #ddd;">
            <el-button @click="saveSetting" class="b1" size="small" v-zoom="{ from: pageName, name: '确定' }" style="margin-top: 10px; width: 98px"
              >确定</el-button
            >&nbsp;
            <el-button
              @click="editDisabled = false"
              class="b2"
              size="small"
              v-zoom="{ from: pageName, name: '修改' }"
              style="margin-top: 10px; width: 98px"
              >修改</el-button
            >
          </div>
        </div>
      </div>
    </div>
      <!--导出数据的短信验证-->
     <el-dialog
      title="身份验证"
      :visible.sync="sendDialog"
      width="520px"
      height="327px"
      style="min-width: 1200px; height: 800px"
    >
      <template slot="title">
        <span>身份验证</span>
      </template>
      <div class="export-dialog-wrapper" style="position: relative; top: -10px">
        <div
          class="sendHug"
          style="
            border-radius: 3px;
            height: 42px;
            line-height: 42px;
            width: 460px;
            background: #fafafa;
          "
        >
          <span
            class="font_family icon-gantanhao"
            style="margin-left: 2px; font-size: 10px; margin-right: 10px"
          ></span>
          <img
            src="@/assets/images/提示-红.svg"
            class="tips-icon"
            style="position: relative; top: 2px; margin-left: 1px"
          />
          <span
            class="font_family icon-gantanhao"
            style="margin-left: 8px; font-size: 10px; margin-right: 2px"
          ></span>
          <span style="font-size: 13px; color: #333333"
            >注：为了保护您的数据安全，关闭【导出数据身份验证】需要手机验证。</span
          >
        </div>
        <div class="hug-send">
          <div class="send-left" style="line-height: 32px; margin-left: 10px">
            手机号：
          </div>
          <div class="send-right" style="display: flex">
            <input
              type="tel"
              class="codeBtn"
              v-model="mobile"
              placeholder=""
              :disabled="true"
              style
            />
            <span
              style="
                line-height: 32px;
                margin-left: 12px;
                font-size: 14px;
                color: #7f85e9;
                cursor: pointer;
              "
              @click="toChangePhone"
              >修改</span
            >
          </div>
        </div>
        <div class="hug-send">
          <div class="send-left" style="line-height: 32px; margin-left: 10px">
            验证码：
          </div>
          <div class="send-right send-right2">
            <input
              type="tel"
              class="codeBtn1"
              v-model="code"
              placeholder="请输入验证码"
              style="padding: 0 8px"
            />
            <el-button
              class="getNumber"
              v-model="codeMsg"
              @click="getCode"
              :disabled="codeDisabled"
              >{{ codeMsg }}</el-button
            >
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="sendDialog = false"
          size="small"
          style="width: 98px; color: #999999; margin: 0 4px 0 0"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="sureExport()"
          style="width: 98px; margin-left: 4px"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!-- 绑定手机号码 -->
    <el-dialog
      title="绑定手机号码"
      :visible.sync="bindDialog"
      width="400px"
      style="min-width: 1200px"
    >
      <template slot="title">
        <span>绑定手机号码</span>
      </template>
      <div class="export-dialog-wrapper">
        <span>为了保护您的数据安全，导出前需绑定手机号码~</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="onceJump"
          style="width: 100px"
          >立即前往</el-button
        >
        <el-button @click="bindDialog = false" size="small" style="width: 100px"
          >取消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { querySellerSetting, updateSellerSetting, checkCodeSet,updateTbPhoneBinding } from "@/api/backstage/a_setting";
import {
  sendSmsSellerCode,
  ExportFile,
} from "@/api/backstage/exportmanage";
import topTitle from "@/components/top-title.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "accountset",
  components: {
    topTitle,
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  data() {
    return {
      phone: "", //用户的手机号
      code: "", //验证码
      codeMsg: "获取验证码", //按钮上的文字
      codeDisabled: false, //按钮可点击？（是否绑定手机）
      timer: null, //验证码定时器
      countdown: 60, // 倒计时秒数
      successMsg: "",
      mobile: "",
      sendDialog: false, //短信验证弹窗
      bindDialog: false, // 绑定手机号码弹窗
      isOpen:'',//开启
      pageName: "后台管理-账户设置",
      userInfo: {
        //获取账号设置的信息
        balanceRemindIsopen: "",
        balanceRemindNum: "",
        sellerNick: "",
        //  mobile:"",
        //  qq:"",
        sendMessageIsopen: "",
        softwareExpireDay: "",
        softwareExpireIsopen: "",
        vcode: "",
        loginRemindIsopen: "",
        succeedMsgIsSend: "",
      },
      userInfoOne: {
        contactName: "",
        vcode: "",
        mobile: "",
        qq: "",
      },
      qqPhone: {}, //qq和手机
      message: {
        //验证码
        vcode: "",
      },
      checkedLin: false, //
      checked: false, //选择框
      checkedOne: false,
      checkedTwo: false,
      checkedThree: false,
      checkedFive: true,
      checkedSix: false,
      buttonContent: "获取验证码",
      totalTime: 60,
      timer: "",
      dis: false,
      bindingPhoneNum: "",
      editDisabled: true,
      multipleSelection: [],
      singRecord: null,
    };
  },
  created () {
    // 埋点
    this.buriedPoint(1, '账户设置', '后台管理', '系统设置')
  },
  mounted: function() {
    this.querySellerSetting();
  },
  methods: {
    // 5.前往绑定手机号码
    onceJump() {
      window.open("/backstage/account/account", "_self");
    },
    //数据导出开启和关闭
    updateTbPhoneBinding(type){
      if(type==2){
        var parmas = {
         "isOpenDownloadRemind": 1, //开启0，关闭1
         "mobile": this.bindingPhoneNum,
         "vCode": this.code
       }
      }else{
        var parmas = {
         "isOpenDownloadRemind": 0,
         "mobile": "",
         "vCode": ""
       }
      }
      updateTbPhoneBinding(parmas).then((res)=>{
         if (res.code == "0") {
            this.$message.error(res.message);
          } else {
            this.$message.success("保存设置成功");
            this.sendDialog = false
            this.querySellerSetting();
          }
      })
    }, 
    // 6.修改手机号
    toChangePhone() {
      //跳转到帐号设置绑定手机
      window.open("/backstage/account/account", "_self");
    },
    //获取验证码
    getCode() {
      let params = {mobile: this.mobile};
      let _that = this;
      _that.codeDisabled = true;
      if(_that.codeMsg!== '获取验证码') return
      //1.获取验证码做手机号码判断
      checkCodeSet({ bindingPhone: this.userInfo.bindingPhone}).then((res)=>{
        if(res.data.code===0){
          this.$message.error(res.message);
        }
      }).catch((e)=>{})
      let clock = window.setInterval(()=>{
        _that.countdown--;
        _that.codeMsg = "重新发送(" + _that.countdown + ")";
        if(_that.countdown === 0){
          window.clearInterval(clock);
          _that.countdown = 60;
          _that.codeMsg = "获取验证码";
          _that.codeDisabled = false;
        }
      },1000)
      this.timeIdx = clock;
    },
    // 7.身份验证-确认导出
    sureExport() {
      this.updateTbPhoneBinding(2)
    },
    //开启关闭
    changeSwitch(e){
     //2为关闭，关闭的时候身份验证
     if(e===2){
      this.mobile = this.qqPhone.mobile
      this.sendDialog = true;
      this.isOpen = 1;
     }else{
      this.updateTbPhoneBinding(1)
     }
    },
    // exportOne(row) {
    //   this.code = "";
    //   this.codeMsg = "获取验证码";
    //   this.timer = null;
    //   this.codeDisabled = false;
    //   this.singRecord = row;
    //   this.successMsg = "";
    //   // 获取当前登录账号信息
    //   // 判断是否绑有手机号
    //   querySellerSetting({
    //     Accept: "*/*",
    //   }).then((res) => {
    //     console.log(res, "判断是否绑有手机号");
    //     this.mobile = res.data.sellerVO.mobile;
    //     //  如果绑定了手机号码，打开短信验证弹窗
    //     if (this.mobile !== "" && this.mobile !== null) {
    //       this.sendDialog = true;
    //     } else {
    //       // 如果没有绑定，打开绑定手机号码弹窗，前往绑定
    //       this.bindDialog = true;
    //     }
    //   });
    // },
    //获取账户信息
    querySellerSetting() {
      querySellerSetting({})
        .then((res) => {
          if (res.data.code == "0") {
            this.$message.error(res.data.message);
          }
          console.log(res, 6666666);
          this.userInfo = res.data.tbPhoneBindingVO;
          this.bindingPhoneNum = res.data.tbPhoneBindingVO.bindingPhone;
          this.qqPhone = res.data.sellerVO;
          let ev =  res.data.tbPhoneBindingVO.isOpenDownloadRemind
          if(ev==1){
            this.isOpen = 2
          }else{
            this.isOpen = 1
          }
          if (this.userInfo.sendMessageIsopen === 1) {
            this.checkedLin = false;
          } else {
            this.checkedLin = true;
          }
          this.checkedFive = res.data.tbPhoneBindingVO.succeedMsgIsSend == "1" ? false : true;
          this.checkedSix = res.data.tbPhoneBindingVO.loginRemindIsopen == "1" ? false : true;
          if (this.userInfo.balanceRemindIsopen === 1) {
            this.checked = false;
          } else {
            this.checked = true;
          }

          if (this.userInfo.softwareExpireIsopen === 1) {
            this.checkedOne = false;
          } else {
            this.checkedOne = true;
          }
        })
        .catch((e) => {});
    },
    checkSms(value) {
      if (value == false) {
        this.userInfo.balanceRemindNum = "";
      }
    },
    checkExp(value) {
      if (value == false) {
        this.userInfo.softwareExpireDay = "";
      }
    },
    //发送验证码
    getMesaage() {
      if (!this.qqPhone.mobile.trim()) {
        return this.$message.error("请输入手机号")
      }
      this.dis = !this.dis;
      this.userInfo.bindingPhone = this.qqPhone.mobile;
      if (this.userInfo.bindingPhone.indexOf("*") > -1) {
        this.userInfo.bindingPhone = this.bindingPhoneNum;
      }
      checkCodeSet({
        bindingPhone: this.userInfo.bindingPhone,
      })
        .then((res) => {
          if(res.code != 1){
            this.$message.error(res.data.message)
          }
        })
        .catch((e) => {});
      let _that = this;
      _that.dis = true;
      let clock = window.setInterval(() => {
        _that.totalTime--;
        _that.buttonContent = _that.totalTime + "s后重新发送";
        if (_that.totalTime === 0) {
          window.clearInterval(clock);
          _that.totalTime = 60;
          _that.buttonContent = "获取验证码";
          _that.dis = false;
        }
      }, 1000);
      this.timer = clock;
    },
    //保存设置
    saveSetting() {
      if (this.checked && this.userInfo.balanceRemindNum == "") {
        this.$message("输入软件条数");
        return;
      }
      if (this.checkedOne && this.userInfo.softwareExpireDay == "") {
        this.$message("输入到期天数");
        return;
      }
      this.userInfo.vcode = this.message.vcode;
      if (this.userInfo.sellerNick && this.userInfo.sellerNick.length > 50) {
        this.$message.error("姓名为不超过50个字的汉字或英文");
        return;
      }
      if (this.userInfo.vcode == "") {
        this.$message.error("验证码不能为空");
        return;
      }
      window.clearInterval(this.timer);
      this.totalTime = 60;
      this.buttonContent = "获取验证码";
      this.dis = false;
      this.userInfo.balanceRemindIsopen = this.checked == true ? 0 : 1;
      this.userInfo.softwareExpireIsopen = this.checkedOne == true ? 0 : 1;
      this.userInfo.sendMessageIsopen = this.checkedLin == true ? 0 : 1;
      this.userInfo.succeedMsgIsSend = this.checkedFive == true ? 0 : 1;
      this.userInfo.loginRemindIsopen = this.checkedSix == true ? 0 : 1;
      this.userInfo.bindingPhone = this.qqPhone.mobile;
      this.userInfoOne.contactName = this.userInfo.sellerNick;
      this.userInfoOne.qq = this.qqPhone.qq;
      this.userInfoOne.mobile = this.qqPhone.mobile;
      this.userInfoOne.vcode = this.message.vcode;


      updateSellerSetting({
        tbPhoneBindingDTO: this.userInfo,
        sellerDTO: this.userInfoOne,
      })
        .then((res) => {
          console.log(res);
          if (res.code == "0") {
            this.$message.error(res.message);
          } else {
            this.$message.success("保存设置成功");
          }
        })
        .catch((err) => {});
    },
    //手机正则表达判断
    checkPhone() {
      var phone = document.getElementById("phone").value;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message("手机号码有误,请重填");
        return false;
      }
      if (this.userInfo.mobile.length < 11) {
        this.dis = true;
      }
    },
    verificationCode() {
      if (this.userInfo.mobile.length < 11) {
        this.dis = true;
      } else {
        this.dis = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* 导出数据模态框 */
.sendHug {
  width: 345px;
  height: 30px;
  background: rgba(255, 118, 0, 0.1);
  margin-left: 10px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 118, 0, 1);
}

.hug-send {
  overflow: hidden;
  margin-top: 20px;

  .send-left {
    float: left;
    height: 20px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    margin-left: 50px;
  }

  .send-right {
    float: left;
    font-size: 15px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 21px;
    color: #333333;
  }

  .send-right2 {
    display: flex;
    height: 32px;
  }

  .codeBtn {
    width: 304px;
    height: 32px;
    display: inline-block;
    line-height: 26px;
    font-size: 15px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #ccc;
    outline-style: none;
    float: left;
    background: #fffffff;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #dddddd;
  }

  .codeBtn1 {
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 110px;
    display: inline-block;
    line-height: 26px;
    font-size: 15px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #666;
    outline-style: none;
    float: left;
    width: 230px;
    height: 32px;
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #dddddd;
  }

  .getNumber {
    width: 100px;
    line-height: 26px;
    margin-left: 12px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }

  .msg {
    font-size: 10px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 14px;
    color: rgba(153, 153, 153, 1);
    text-align: center;
  }}
.titileDefinition {
  min-width: 1046px;
  height: 57px;
  background-color: #fff;
  line-height: 57px;
  padding: 0 30px;
  font-size: 16px;
  color: #2e3458;
  font-weight: bold;
  margin: 20px;
  border: 1px solid rgba(230, 230, 230, 1);
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
.fenHao {
  width: 6px;
  height: 8px;
  color: rgba(255, 58, 39, 1);
  opacity: 1;
  vertical-align: middle;
  margin-left: 12px;
}
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 26px 30px;
  border: 1px solid rgba(230, 230, 230, 1);
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  opacity: 1;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 20px;
  .checked-content-box {
    .background {
      height: 32px;
      background: rgba(250, 250, 250, 1);
      opacity: 1;
      line-height: 32px;
      padding-left: 12px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
    }
    .tips-box {
      width: 818px;
      height: 42px;
      line-height: 42px;
      position: relative;
      font-size: 14px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 25px;
      .background-span {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.1;
        top: 0;
        left: 0;
      }
    }
    .checked-box {
      font-size: 14px;
      padding-left: 10px;
      margin-top: 5px;
      margin-left: 40px;
      .check {
        display: block;
        margin-bottom: 16px;
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 72px;
          margin: 0 4px;
        }
      }
    }
  }
  .input-content-box {
    margin-top: 30px;
    .background {
      height: 32px;
      background: rgba(250, 250, 250, 1);
      opacity: 1;
      line-height: 32px;
      padding-left: 12px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
    }
    .tips-box {
      width: 818px;
      height: 42px;
      line-height: 42px;
      position: relative;
      font-size: 14px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 25px;
      .background-span {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.1;
        top: 0;
        left: 0;
      }
    }
    .b1 {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .b2 {
      width: 98px;
      height: 32px;
      color: #666666;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .input-box {
      font-size: 14px;
      margin-top: 10px;
      padding-left: 55px;
      .item {
        margin-bottom: 10px;
        .item-name {
          display: inline-block;
          vertical-align: middle;
          // color: #333333;
          width: 40px;
        }
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 300px;
        }
        .code-input {
          display: inline-block;
          vertical-align: middle;
          width: 156px;
          margin-right: 12px;
        }
        .code-button {
          display: inline-block;
          vertical-align: middle;
          width: 130px;
          height: 32px;
          line-height: 30px;
          text-align: center;
          border-radius: 6px;
          background-color: #fff;
          cursor: pointer;
          > span {
            display: inline-block;
            position: relative;
            top: -12px;
          }
        }
      }
      .save-button {
        width: 167px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        margin-left: 60px;
      }
      .save-button:hover {
        opacity: 0.8;
      }
    }
  }
  
}
</style>
